import React from 'react';
import { Checkbox, Select, Input } from 'antd';
import styled from 'styled-components';

import { customSequenceTypes, dimensionTypes } from '../../../constants/retention';
import RetentionDimensionSelect from '../RetentionDimensionSelect';
import DocsLink from '../../docs/DocsLink';
import docsBookmarks from '../../../constants/docs';

const { Option } = Select;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;

  .main {
    margin-top: 9px;
  }

  .label {
    margin-right: 10px;
  }

  .inputs-container {
    display: flex;
    align-items: center;
  }

  .custom-sequence-container {
    display: flex;
    align-items: flex-start;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  white-space: nowrap;
  margin-top: 9px;
`;

const StyledInput = styled(Input)`
  width: 50px;
  text-align: center;
`;

const StyledFirstSelect = styled(Select)`
  width: 120px;
  margin-right: 15px;
`;

const StyledSecondSelect = styled(Select)`
  min-width: 120px;
`;

const RetentionCustomSequencePicker = ({
  enabled,
  sequence,
  sequenceType,
  sequenceDimensions,
  onToggle,
  onSequenceTypeChange,
  onSequenceChange,
  onSequenceFromChange,
  onSequenceToChange,
  onCustomSequenceCalculate,
  dimensionType,
  onDimensionTypeChange,
}) => (
  <StyledContainer>
    <div>
      <RetentionDimensionSelect
        dimensionType={dimensionType}
        onDimensionTypeChange={onDimensionTypeChange}
      />
      {(dimensionType === dimensionTypes.WEEKLY || dimensionType === dimensionTypes.MONTHLY) && (
        <DocsLink
          scrolTo={docsBookmarks.retentionTimeRange}
          styleIcon={{ fontSize: 20, marginLeft: 5, color: 'gray' }}
        />
      )}
    </div>

    <StyledCheckbox onChange={onToggle} checked={enabled}>
      Custom sequence
    </StyledCheckbox>
    <div className="main">
      {enabled && (
        <div className="custom-sequence-container">
          <StyledFirstSelect
            dropdownMatchSelectWidth
            dropdownStyle={{ width: 'auto' }}
            value={sequenceType || undefined}
            onSelect={onSequenceTypeChange}
            className="ant-select-border-bottom"
            getPopupContainer={(triggerNode) => triggerNode}
            virtual={false}
          >
            <Option value={customSequenceTypes.RANGE}>Range</Option>
            <Option value={customSequenceTypes.MANUAL}>Manual</Option>
          </StyledFirstSelect>
          {sequenceType === customSequenceTypes.MANUAL ? (
            <StyledSecondSelect
              mode="tags"
              placeholder="Sequence"
              tokenSeparators={[',']}
              value={sequence}
              onChange={(sequenceArray) => {
                const sortedSequence = sequenceArray.map((s) => +s).sort((a, b) => a - b);
                onSequenceChange(sortedSequence);
              }}
              dropdownStyle={{ display: 'none' }}
              getPopupContainer={(triggerNode) => triggerNode}
              virtual={false}
            />
          ) : (
            <div className="inputs-container">
              <span className="label">from</span>
              <StyledInput
                className="ant-input-border-bottom"
                placeholder="From"
                value={sequenceDimensions.from}
                onChange={(e) => onSequenceFromChange(+e.target.value)}
                onBlur={onCustomSequenceCalculate}
              />
              <span className="label">to</span>
              <StyledInput
                className="ant-input-border-bottom"
                placeholder="To"
                value={sequenceDimensions.to}
                onChange={(e) => onSequenceToChange(+e.target.value)}
                onBlur={onCustomSequenceCalculate}
              />
            </div>
          )}
        </div>
      )}
    </div>
  </StyledContainer>
);

export default RetentionCustomSequencePicker;
